import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["aria-label", "aria-labelledby", "className", "renderMenuIcon", "renderCloseIcon", "isActive", "isCollapsible"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Menu, Close } from '@carbon/icons-react';
import cx from 'classnames';
import React__default from 'react';
import PropTypes from 'prop-types';
import { AriaLabelPropType } from '../../prop-types/AriaPropTypes.js';
import { usePrefix } from '../../internal/usePrefix.js';
var _Menu, _Close;
function HeaderMenuButton(_ref) {
  var _objectSpread2;
  var ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    customClassName = _ref.className,
    renderMenuIcon = _ref.renderMenuIcon,
    renderCloseIcon = _ref.renderCloseIcon,
    isActive = _ref.isActive,
    isCollapsible = _ref.isCollapsible,
    rest = _objectWithoutProperties(_ref, _excluded);
  var prefix = usePrefix();
  var className = cx(_objectSpread(_objectSpread({}, typeof customClassName === 'string' && _defineProperty({}, customClassName, !!customClassName)), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "".concat(prefix, "--header__action"), true), _defineProperty(_objectSpread2, "".concat(prefix, "--header__menu-trigger"), true), _defineProperty(_objectSpread2, "".concat(prefix, "--header__action--active"), isActive), _defineProperty(_objectSpread2, "".concat(prefix, "--header__menu-toggle"), true), _defineProperty(_objectSpread2, "".concat(prefix, "--header__menu-toggle__hidden"), !isCollapsible), _objectSpread2)));
  var menuIcon = renderMenuIcon ? renderMenuIcon : _Menu || (_Menu = /*#__PURE__*/React__default.createElement(Menu, {
    size: 20
  }));
  var closeIcon = renderCloseIcon ? renderCloseIcon : _Close || (_Close = /*#__PURE__*/React__default.createElement(Close, {
    size: 20
  }));
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: className,
    title: ariaLabel,
    type: "button"
  }), isActive ? closeIcon : menuIcon);
}
HeaderMenuButton.propTypes = _objectSpread(_objectSpread({}, AriaLabelPropType), {}, {
  /**
   * Optionally provide a custom class name that is applied to the underlying
   * button
   */
  className: PropTypes.string,
  /**
   * Specify whether the menu button is "active".
   */
  isActive: PropTypes.bool,
  /**
   * Specify whether the menu button is collapsible.
   */
  isCollapsible: PropTypes.bool,
  /**
   * Optionally provide an onClick handler that is called when the underlying
   * button fires it's onclick event
   */
  onClick: PropTypes.func
});
export { HeaderMenuButton as default };